export const getCssVariable = (variable: string): string | number => {
    const value = getComputedStyle(document.documentElement).getPropertyValue(variable);
    if (Number.isNaN(Number(value))) {
        return value.replace(/['"]+/g, '');
    }
    return Number(value);
};

export const getTypedCssVariable = <T>(variable: string): T => {
    return getCssVariable(variable) as T;
};
